import { render, staticRenderFns } from "./taxonomy-card.vue?vue&type=template&id=7ae074a2&"
import script from "./taxonomy-card.ts?vue&type=script&lang=ts&"
export * from "./taxonomy-card.ts?vue&type=script&lang=ts&"
import style0 from "./taxonomy-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports